// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__+VYvn","table":"Table_table__6PGuw","row":"Table_row__s+qMz","col":"Table_col__DcU6z"};